export default {
    // Navbar
    nav: {
      home: 'Inizio',
      about: 'Chi Sono',
      strategies: 'Strategie',
      performance: 'Rendimento',
      portfolioBuilder: 'Costruttore di Portfolio',
      insights: 'Analisi',
      reports: 'Report Settimanali',
      terminal: 'Quant Lab',
      contact: 'Contatto',
      institutional: 'Investitori Istituzionali',
    },
    
    // Home Page
    home: {
      ticker: {
        subtitle: 'Trading Quantitativo · Strategie Sistematiche',
      },
      hero: {
        title: 'HMA Quant Strategies',
        description: 'Analista Quantitativo che sviluppa strategie algoritmiche con rendimenti annualizzati superiori al',
        cagr: '40% CAGR',
        and: 'e',
        sharpe: 'Sharpe > 1.5',
        additionalPrefix: 'Con',
        drawdowns: 'drawdown',
        additionalMiddle: 'inferiori al',
        drawdownValue: '15%',
        additionalAnd: 'e dati storici che coprono oltre',
        years: '20 anni',
        ctaPrimary: 'Esplora le Strategie',
        ctaSecondary: 'Chi Sono',
      },
      featured: {
        label: 'Strategia in Evidenza',
        cta: 'Esplora ARES →',
        subtitle: 'Eccellenza nel Market Timing',
        description: 'Sistema quantitativo sviluppato con rigore accademico. Validato su quasi 20 anni di dati storici, inclusa la crisi del 2008, COVID-19 e i cicli dei tassi 2022-2024.',
      },
      tech: {
        label: 'Infrastruttura Quantitativa',
        title: 'STRUMENTI MATEMATICI E ',
        titleAccent: 'COMPUTAZIONALI',
        footer: 'Strategie sistematiche validate attraverso backtesting rigoroso su dati di livello istituzionale',
      },
      timeline: {
        label: 'Percorso Professionale',
        title: 'TAPPE ',
        titleAccent: 'PROFESSIONALI',
        milestones: [
          {
            title: 'Laurea in Fisica',
            description: 'Completamento della laurea universitaria con specializzazione in fisica teorica e matematica applicata.',
          },
          {
            title: 'Master in Finanza Quantitativa',
            description: 'Formazione specializzata in modellizzazione matematica, analisi quantitativa e sviluppo di strategie algoritmiche.',
          },
          {
            title: 'Hedge Fund + Strategia Algoritmica',
            description: 'Inizio presso un hedge fund spagnolo. Sviluppo e implementazione di strategia algoritmica basata sui dividendi.',
          },
          {
            title: 'Broker Londinese (FTSE 100)',
            description: 'Ingresso nel broker londinese, componente dell\'indice FTSE 100, lavorando nello sviluppo quantitativo.',
          },
          {
            title: 'Strategie in Produzione',
            description: 'Messa in produzione di molteplici strategie algoritmiche con capitale reale. Portfolio di trading sistematico operativo.',
          },
        ],
      },
      features: {
        title: 'Perché investire con strategie quantitative?',
        subtitle: 'Sistemi algoritmici basati su dati, backtesting rigoroso e gestione del rischio istituzionale',
        items: [
          {
            title: 'Momentum & Timing',
            description: '+40% CAGR in strategie di momentum e market timing validate su 15 anni di dati storici'
          },
          {
            title: 'Modelli Bayesiani',
            description: 'Hidden Markov Models per il rilevamento del regime di mercato e l\'adattamento dinamico'
          },
          {
            title: 'Market Neutral',
            description: 'Strategie long-short con analisi correlazionale Beta/R² per ridurre l\'esposizione direzionale'
          },
          {
            title: 'Sistemi Automatizzati',
            description: 'Trading intraday completamente automatizzabile in prop firm e broker istituzionali'
          },
          {
            title: 'Multi-Asset',
            description: 'Azioni USA, indici, cripto, volatilità (VIX) - vera diversificazione'
          },
          {
            title: 'Track Record Istituzionale',
            description: 'Esperienza nella gestione di portafogli fino a $200M presso hedge fund e broker FTSE 100'
          }
        ]
      },
      cta: {
        title: 'Pronto a iniziare?',
        subtitle: 'Scopri le mie strategie su Darwinex, eToro e Wikifolio, o leggi la mia analisi quantitativa su Substack',
        ctaPrimary: 'Dove Investire',
        ctaSecondary: 'Contatto'
      }
    },

    // About Me Page
    about: {
      title: 'Analista Quantitativo',
      intro1: 'Analista Quantitativo con formazione in',
      physics: 'Fisica (BSc)',
      and: 'e',
      finance: 'finanza quantitativa (MSc)',
      intro2: '. Attualmente lavora presso un rinomato broker di Londra (FTSE 100), sviluppando modelli statistici e strategie di trading sistematico.',
      intro2b: 'Attualmente candidato CFA (Chartered Financial Analyst) — la certificazione più prestigiosa e riconosciuta a livello globale nel settore degli investimenti.',
      intro3: 'Con esperienza precedente nella gestione di portafogli fino a',
      amount: '$200M presso un hedge fund spagnolo',
      intro4: ', e nel pricing e gestione del rischio di derivati energetici presso un fondo commodities, combina rigore matematico, machine learning e profonda conoscenza dei mercati per costruire algoritmi robusti e riproducibili.',
      trackRecordTitle: 'Track Record',
      trackRecordTitle2: 'Costruendo strategie quantitative che generano rendimenti corretti per il rischio consistenti in qualsiasi regime di mercato.',
      trackRecordParagraph1: 'L\'esperienza professionale comprende l\'ottimizzazione di strategie sistematiche, migliorando i rendimenti corretti per il rischio dal 12% al 23% annuo, e contribuendo alla gestione di portafogli e ricerca che copre asset in gestione superiori a €200M.',
      trackRecordParagraph2: 'Ha progettato e testato oltre 40 modelli quantitativi in azioni, derivati e titoli a reddito fisso. Ogni strategia è stata testata su decenni di dati storici e validata attraverso paper trading dal vivo e condizioni di mercato reali.',
      trackRecordParagraph3: 'Individualmente, ogni strategia mira a un rischio controllato all\'interno della sua asset class. Combinate in un portafoglio diversificato, raggiungono rapporti di Sharpe superiori a 1.5 e drawdown massimi sotto il -15%, con correlazione quasi zero rispetto ai benchmark tradizionali.',
      trackRecordDisclaimer: 'Risultati basati su backtesting e paper trading dal vivo. I rendimenti passati non garantiscono rendimenti futuri. Tutti i rendimenti sono ipotetici salvo esplicitamente indicato come live.',
      trackRecordParagraph4: 'Da portafogli azionari basati sul momentum all\'arbitraggio statistico market-neutral, dalla cattura della volatilità al macro quantitativo, che tu sia un investitore retail alla ricerca di esposizione sistematica o un\'istituzione alla ricerca di flussi di rendimento decorrelati, costruiamo strategie adatte al tuo profilo di rischio e ai tuoi obiettivi.',
      intro3: 'Con esperienza precedente nella gestione di portafogli fino a',
      amount: '$200M presso un hedge fund spagnolo',
      intro4: ', e nel pricing e gestione del rischio di derivati energetici presso un fondo commodities, combina rigore matematico, machine learning e profonda conoscenza dei mercati per costruire algoritmi robusti e riproducibili.',
      trackRecordTitle: 'Track Record',
      trackRecordDescription: 'Costruendo strategie quantitative che generano rendimenti corretti per il rischio consistenti in qualsiasi regime di mercato. Il nostro track record parla attraverso i numeri: dodici strategie indipendenti progettate per minimizzare i drawdown massimizzando l\'alpha, ciascuna testata su decenni di dati storici e validata in paper trading dal vivo. Individualmente, ogni strategia cerca un rischio controllato all\'interno della sua asset class. Combinate in un portafoglio diversificato, raggiungono rapporti di Sharpe superiori a 1.5 e drawdown massimi contenuti sotto il -15%, con correlazione prossima allo zero rispetto ai benchmark tradizionali. Da portafogli di momentum azionario ad arbitraggio statistico market-neutral, da cattura della volatilità a macro quantitativo, che tu sia un investitore privato alla ricerca di esposizione sistematica o un\'istituzione alla ricerca di fonti di rendimento decorrelate, costruiamo strategie che si adattano al tuo profilo di rischio e obiettivi.',
      expertiseTitle: 'Competenze',
      expertise: [
        '+40% CAGR in strategie di momentum e timing',
        'Modelli bayesiani con Hidden Markov Models per il rilevamento del regime',
        'Strategie market neutral con analisi correlazionale Beta/R²',
        'Sistemi intraday completamente automatizzabili in prop firm',
        'Multi-asset: azioni USA, indici, cripto, volatilità (VIX)',
        'Track record istituzionale: gestione di portafogli fino a $200M',
      ],
      toolsTitle: 'Strumenti Matematici e Computazionali',
      toolsSubtitle: 'Tecnologie e framework che utilizzo per la ricerca quantitativa e il trading sistematico',
      clickToFlip: 'Clicca per vedere di più',
      clickToFlipBack: 'Clicca per tornare',
      clickForDetails: 'Clicca per maggiori dettagli →',
      clickToClose: 'Clicca per chiudere ←',
      tools: {
        python: {
          name: 'Python',
          description: 'Linguaggio principale per backtesting, analisi statistica e sviluppo di strategie'
        },
        numpy: {
          name: 'NumPy',
          description: 'Pacchetto fondamentale per il calcolo numerico e operazioni su array'
        },
        pandas: {
          name: 'Pandas',
          description: 'Manipolazione e analisi di dati ad alte prestazioni per serie temporali'
        },
        scikit: {
          name: 'Scikit-learn',
          description: 'Modelli di machine learning per il riconoscimento di pattern e analisi predittiva'
        },
        tensorflow: {
          name: 'TensorFlow',
          description: 'Framework di deep learning per modellare comportamenti complessi del mercato'
        },
        pytorch: {
          name: 'PyTorch',
          description: 'Reti neurali dinamiche per ricerca avanzata in deep learning'
        },
        git: {
          name: 'Git',
          description: 'Controllo di versione per gestione del codice e sviluppo collaborativo'
        },
        vscode: {
          name: 'VS Code',
          description: 'IDE professionale per sviluppo efficiente di codice e debugging'
        },
        jupyter: {
          name: 'Jupyter',
          description: 'Notebook interattivi per ricerca, visualizzazione e prototipazione di strategie'
        },
        quantlib: {
          name: 'QuantLib',
          description: 'Libreria di finanza quantitativa per pricing di derivati e gestione del rischio'
        },
        backtrader: {
          name: 'Backtrader',
          description: 'Framework Python per backtesting e trading dal vivo di strategie'
        },
        postgresql: {
          name: 'PostgreSQL',
          description: 'Database relazionale robusto per lo storage di dati finanziari strutturati'
        },
        mongodb: {
          name: 'MongoDB',
          description: 'Database NoSQL per storage flessibile di dati di mercato non strutturati'
        },
        docker: {
          name: 'Docker',
          description: 'Containerizzazione per deployment consistente in diversi ambienti'
        },
        aws: {
          name: 'AWS',
          description: 'Infrastruttura cloud per calcolo scalabile e processamento dati'
        },
        mathematics: {
          name: 'Matematica',
          description: 'Concetti matematici avanzati alla base della finanza quantitativa'
        },
        statistics: {
          name: 'Statistica',
          description: 'Metodi statistici per test di ipotesi e inferenza'
        },
        linearalgebra: {
          name: 'Algebra Lineare',
          description: 'Operazioni matriciali per ottimizzazione di portafogli e modelli fattoriali'
        },
        timeseries: {
          name: 'Serie Temporali',
          description: 'Analisi di dati temporali per previsioni e rilevamento di tendenze'
        },
        calculus: {
          name: 'Calcolo',
          description: 'Derivate e integrali per pricing di opzioni e ottimizzazione'
        },
        probability: {
          name: 'Probabilità',
          description: 'Modelli probabilistici per valutazione del rischio e processo decisionale'
        },
        optimization: {
          name: 'Ottimizzazione',
          description: 'Ottimizzazione matematica per allocazione di portafoglio e tuning di strategie'
        },
        bayesian: {
          name: 'Bayesiano',
          description: 'Inferenza bayesiana per rilevamento di regimi e stima di parametri'
        },
        stochasticcalculus: {
          name: 'Calcolo Stocastico',
          description: 'Processi stocastici per modellare dinamiche di prezzo e derivati'
        },
        montecarlo: {
          name: 'Monte Carlo',
          description: 'Metodi di simulazione per analisi del rischio e test di scenari'
        }
      },
      ctaTitle: 'Pronto a investire in modo diverso?',
      ctaSubtitle: 'Esplora le mie strategie quantitative o mettiti in contatto con me.',
      ctaStrategies: 'Vedi Strategie',
      ctaContact: 'Contatto',
      milestones: [
        {
          title: 'Laurea in Fisica',
          description: 'Completamento della laurea universitaria con specializzazione in fisica teorica e matematica applicata.',
          shortDetail: 'Fondamenti in calcolo, algebra lineare, meccanica quantistica, meccanica statistica, elettromagnetismo, relatività e programmazione scientifica in Python/Fortran/C.'
        },
        {
          title: 'Master in Finanza Quantitativa',
          description: 'Formazione specializzata in modellizzazione matematica, analisi quantitativa e sviluppo di strategie algoritmiche.',
          shortDetail: 'Programmazione Python, econometria, derivati, gestione di portafogli, machine learning, deep learning, NLP, reinforcement learning, deployment AWS e quantum computing.'
        },
        {
          title: 'Hedge Fund',
          description: 'Ingresso in hedge fund spagnolo lavorando con clienti istituzionali di primo livello.',
          shortDetail: 'Analista quantitativo gestendo portafogli per Edmond de Rothschild, Millennium e società americane. Studi data-driven, ottimizzazione di processi e ricerca quantitativa.'
        },
        {
          title: 'Trading Energetico',
          description: 'Trading e gestione del rischio nei mercati energetici globali per azienda olandese.',
          shortDetail: 'Opportunità di trading nelle interconnessioni europee. Progetti di ottimizzazione per Repsol, Glencore, TMS. Reuters Eikon, sviluppo di ETRM, solver CPLEX/Gurobi, pricing Monte Carlo.'
        },
        {
          title: 'IG Group (FTSE 100)',
          description: 'Analista quantitativo presso broker FTSE 100, sviluppando modelli ML per ottimizzazione del trading e gestione del rischio.',
          shortDetail: 'Modelli XGBoost/Random Forest per gestione del rischio come market maker. Ricerca statistica, pipeline di PnL, dashboard GCP/BigQuery/Streamlit. Reporting per team di Londra e Melbourne.'
        },
        {
          title: 'Strategie in Produzione',
          description: 'Sviluppo e operazione di strategie algoritmiche proprietarie con capitale reale in diverse asset class.',
          shortDetail: 'Market neutral, momentum, pair trading, trading basato su ML, forex, cripto, strategie di volatilità. Pipeline completa dall\'ipotesi all\'esecuzione dal vivo. Vedi sezione Strategies per maggiori dettagli.'
        }
      ],
      eventsTitle: 'EVENTI',
      eventsAttendTitle: 'EVENTI A CUI PARTECIPO / CONSIGLIO',
      eventsOrganizeTitle: 'EVENTI CHE ORGANIZZO / IN CUI PARLO',
      eventAttending: 'PARTECIPANTE',
      eventOrganizer: 'ORGANIZZATORE',
      eventQuantConference: 'Conferenza Finanza Quantitativa',
      eventQuantConferenceLocation: 'Londra, Giugno 2026',
      eventQuantConferenceDesc: 'Evento leader per ricercatori e professionisti quantitativi. Focus su trading sistematico e gestione del rischio.',
      eventQuantMeetup: 'Meetup Finanza Quantitativa',
      eventQuantMeetupLocation: 'Madrid, 2025',
      eventQuantMeetupDesc: 'Evento comunitario organizzato per ricercatori e professionisti quantitativi. Focus su condivisione di strategie di trading sistematico e networking.',
      eventsComingSoon: 'Altri eventi in arrivo...',
      podcastsTitle: 'PODCAST · PROSSIMAMENTE',
      podcastsDescription: 'Una serie di conversazioni con professionisti, ricercatori e costruttori nella finanza quantitativa. Attualmente in fase di pianificazione. Per ricevere una notifica al lancio, iscriviti tramite la pagina dei contatti.',
      disclaimer: 'Le informazioni fornite su questo sito sono solo a scopo educativo e informativo. Non costituiscono consulenza finanziaria, di investimento o di trading. Le performance passate non garantiscono risultati futuri. Consulta sempre un consulente finanziario autorizzato prima di prendere decisioni di investimento.',
    },

    // Strategies Page
    strategies: {
      title: 'Strategie Quantitative',
      subtitle: 'Sistemi algoritmici di livello istituzionale con backtesting rigoroso',
      compareTitle: 'Confronto delle Performance',
      compareSubtitle: 'Confronta le metriche chiave di tutte le strategie',
      riskLevel: 'Livello di Rischio',
      moderate: 'Moderato',
      high: 'Alto',
      veryHigh: 'Molto Alto',
      viewStrategy: 'Visualizza Strategia',
      equityCurve: 'CURVA DI EQUITY',
      drawdownAnalysis: 'ANALISI DEL DRAWDOWN',
      maxDrawdownComparative: 'MAX DRAWDOWN COMPARATIVO',
      comparativeMetrics: 'METRICHE COMPARATIVE',
      correlation: 'CORRELAZIONE',
      correlationWithBenchmarks: 'CORRELAZIONE CON I BENCHMARK',
      downloadBrochure: '📄 Scarica Brochure',
      annualReturns: 'Rendimenti Annuali',
      historicalDataDisclaimer: '* Dati storici periodo {start} - {end}. I risultati passati non garantiscono rendimenti futuri.',
      strategyNames: {
        tyr: 'Strategia TYR',
        ares: 'Strategia ARES',
        ascalafo: 'Strategia ASCÁLAFO',
        deimos: 'Strategia DEIMOS',
        fobos: 'Strategia FOBOS',
        bes: 'Strategia BES',
        janus: 'Strategia JANUS',
        hraesvelgr: 'Strategia HRÆSVELGR',
      },
      metrics: {
        cagr: 'CAGR',
        sharpe: 'Sharpe',
        maxDD: 'Max DD',
        volatility: 'Volatilità',
      },
      strategyDescriptions: {
        tyr: 'Rotazione dual-momentum',
        ares: 'Market timing',
        ascalafo: 'Doppio strato',
        deimos: 'Market timing + rischio',
        fobos: 'Doppio strato + rischio',
        bes: 'Trend following',
        janus: 'Rotazione settoriale',
        hraesvelgr: 'All Weather aggressivo',
      },
      strategyFullDescriptions: {
        tyr: 'TYR prende il nome dal dio nordico dell\'ordine, della giustizia e della protezione, un simbolo appropriato per una strategia progettata per navigare i mercati con disciplina e resilienza. TYR è una strategia quantitativa di rotazione dual-momentum ispirata ai principi della filosofia All Weather di Ray Dalio.',
        ares: 'ARES è una strategia quantitativa proprietaria di market timing. Sviluppata e validata su quasi 20 anni di dati storici (2006–2026), ha dimostrato robustezza attraverso gli episodi di maggiore stress del mercato moderno: il crash finanziario del 2008, la pandemia del 2020, il ciclo aggressivo di rialzi dei tassi del 2022 e la volatilità estrema del 2024–2025.',
        ascalafo: 'Strategia proprietaria di market timing a doppio strato sul mercato americano. Due sistemi di segnale indipendenti che si combinano per massima precisione di entrata/uscita. 100% sistematico, esposizione binaria controllata.',
        deimos: 'DEIMOS è una strategia quantitativa proprietaria di market timing con maggiore rischio controllato. Sviluppata e validata su quasi 20 anni di dati storici (2006–2026), ha dimostrato robustezza attraverso gli episodi di maggiore stress del mercato moderno. Con un profilo di rischio più aggressivo di ARES, cerca di massimizzare i rendimenti nei mercati rialzisti mantenendo disciplina sistematica.',
        fobos: 'Strategia proprietaria di market timing a doppio strato sul mercato americano con profilo ad alto rischio/rendimento. Due sistemi di segnale indipendenti che si combinano per massima precisione di entrata/uscita. 100% sistematico, esposizione binaria controllata con leva ottimizzata per investitori con maggiore tolleranza al rischio.',
        bes: 'BES is a systematic trend-following strategy focused on medium-term growth. It holds names that are technically outrunning the broad market, combining relative strength, momentum and trend stability to filter noise.',
        janus: 'JANUS è un sistema di selezione quantitativa di azioni con ribilanciamento settimanale completo, che opera in modalità Long-Short Market Neutral. Il suo nome evoca il dio romano dalle due facce — esattamente la dualità di prendere posizioni lunghe e corte simultaneamente.',
        hraesvelgr: 'HRÆSVELGR is TYR’s more aggressive twin in the All Weather family. Same regime discipline, more appetite for growth, and a faster shift to defence when momentum fades.',
      },
    },

    // Portfolio Builder Page
    portfolioBuilder: {
      title: 'Costruttore di Portfolio',
      subtitle: 'Costruisci il tuo portfolio personalizzato combinando multiple strategie quantitative',
      riskWarning: {
        title: '⚠ AVVISO DI RISCHIO',
        content: 'Le strategie quantitative comportano il rischio di perdita di capitale. Le performance storiche mostrate si basano su backtesting e simulazione — non garantiscono rendimenti futuri. Questo è uno strumento educativo, non consulenza d\'investimento, raccomandazione o sollecitazione all\'acquisto o vendita di titoli.',
      },
      hero: {
        heading1: 'COSTRUISCI IL TUO',
        heading2: 'PORTFOLIO IDEALE',
        description: 'Esplora combinazioni di portfolio tra le nostre strategie. Questo strumento permette di simulare allocazioni, analizzare metriche storiche e comprendere come diverse ponderazioni strategiche influenzano i rendimenti aggiustati per il rischio. Questo è uno strumento educativo — non una consulenza d\'investimento personalizzata.',
        disclaimer: 'Solo strumento educativo. Risultati simulati basati su dati storici. Non costituisce consulenza d\'investimento.',
      },
      tabs: {
        build: 'Costruire Portfolio',
        models: 'Portfolio Modello',
        saved: 'Portfolio Salvati',
      },
      buildSection: {
        selectTitle: 'Selezionare Strategie',
        selectSubtitle: 'Scegli almeno 2 strategie da combinare',
        weightsTitle: 'Assegnare Pesi',
        weightsSubtitle: 'Il totale deve sommare al 100%',
        totalWeight: 'Peso Totale',
        distributeEqually: 'Distribuire Equamente',
        optimize: 'Auto Ottimizzare (Sharpe)',
        generate: 'Generare Portfolio',
        validationError: 'Seleziona almeno 2 strategie e assicurati che i pesi sommino al 100%',
        optimizeSuccess: 'Portfolio ottimizzato con Sharpe atteso:',
        optimizeError: 'Errore nell\'ottimizzazione del portfolio',
      },
      modelsSection: {
        title: 'Portfolio Modello',
        subtitle: 'Portfolio preconfigurati per diversi profili di rischio',
        usePortfolio: 'Usa Questo Portfolio',
        questionnaire: 'Compilare Questionario',
      },
      savedSection: {
        title: 'Portfolio Salvati',
        subtitle: 'Accedi alle tue configurazioni di portfolio salvate in precedenza',
        noSaved: 'Nessun portfolio salvato ancora',
        load: 'Caricare',
        delete: 'Eliminare',
      },
      results: {
        title: 'Risultati del Portfolio',
        composition: 'Composizione del Portfolio',
        metrics: 'Metriche Chiave',
        performance: 'Performance Storica',
        returns: 'Rendimenti Mensili',
        exportPDF: 'Scaricare Report del Portfolio',
        save: 'Salvare Portfolio',
        saveSuccess: 'Portfolio salvato con successo!',
        saveError: 'Errore nel salvare il portfolio',
        period: 'Periodo',
        strategies: 'Strategie',
        tabs: {
          equity: 'Curva di Capitale',
          drawdown: 'Drawdown',
          annual: 'Rendimenti Annuali',
        },
      },
      modelPortfolios: {
        conservative: {
          name: 'Conservativo',
          description: 'Bassa volatilità, enfasi sulla preservazione del capitale',
          riskLevel: 'Basso',
        },
        balanced: {
          name: 'Bilanciato',
          description: 'Equilibrio tra crescita e gestione del rischio',
          riskLevel: 'Moderato',
        },
        growth: {
          name: 'Crescita',
          description: 'Focus su rendimenti più alti con maggiore volatilità',
          riskLevel: 'Alto',
        },
        aggressive: {
          name: 'Aggressivo',
          description: 'Massimizzazione dei rendimenti, volatilità elevata',
          riskLevel: 'Molto Alto',
        },
      },
      questionnaire: {
        title: 'Questionario di Profilo di Rischio',
        subtitle: 'Rispondi a queste domande per trovare il portfolio adatto a te',
        questions: [
          {
            question: 'Qual è il tuo orizzonte temporale di investimento?',
            options: [
              'Meno di 1 anno',
              '1-3 anni',
              '3-5 anni',
              'Più di 5 anni'
            ]
          },
          {
            question: 'Come reagiresti a una perdita del 20% nel tuo portfolio?',
            options: [
              'Venderei tutto immediatamente',
              'Venderei parte del portfolio',
              'Manterrei il portfolio',
              'Investirei di più'
            ]
          },
          {
            question: 'Qual è il tuo obiettivo principale?',
            options: [
              'Preservare il capitale',
              'Reddito stabile',
              'Crescita moderata',
              'Massima crescita'
            ]
          }
        ],
        submit: 'Ottenere Raccomandazione',
      },
      common: {
        selectStrategies: 'Seleziona Strategie',
        selectedStrategies: 'Strategie Selezionate',
        allocation: 'Allocazione',
        projectedMetrics: 'Metriche Previste',
        initialInvestment: 'Investimento Iniziale',
        monthlyContribution: 'Contributo Mensile',
        timeHorizon: 'Orizzonte Temporale',
        years: 'anni',
        projectedValue: 'Valore Previsto',
        totalInvested: 'Totale Investito',
        totalReturns: 'Rendimenti Totali',
        riskWarning: '⚠️ Avviso sul Rischio',
        riskWarningText: 'Questo è uno strumento educativo. I rendimenti previsti si basano su performance storiche e non garantiscono risultati futuri. Il trading comporta rischi. Consulta un consulente finanziario.',
        resetPortfolio: 'Reset Portfolio',
        chart: {
          portfolioGrowth: 'Crescita del Portfolio',
          invested: 'Investito',
          projected: 'Previsto',
        },
        summary: {
          summary: 'Riepilogo:',
          summaryText1: 'Con un investimento iniziale di',
          summaryText2: 'e contributi mensili di',
          summaryText3: ', avresti investito un totale di',
          summaryText4: 'durante',
          summaryText5: ', ottenendo un valore finale di',
          years: 'anni',
        },
      },
    },

    // Insights Page
    insights: {
      title: 'Analisi',
      subtitle: 'Strategie, analisi e risorse per investire in modo intelligente',
      substackSection: {
        title: 'ULTIMI ARTICOLI DA SUBSTACK',
        loading: 'Caricamento ultime pubblicazioni...',
        error: 'Impossibile caricare articoli. Riprova più tardi.',
        errorWithLink: 'Articoli recenti su Substack:',
      },
      newsletterTitle: 'HMA Quant Newsletter',
      visitSubstack: 'Visita il mio Substack',
      weeklyNewsletter: 'Newsletter Settimanale',
      analysisAndNewsletter: 'Insights & Newsletter',
      subscribe: 'Iscriviti',
      newsletterIntro: 'Condivido analisi quantitative, tesi di investimento e note giornaliere sulla mappa delle opzioni S&P500 sul mio Substack',
      newsletterDescription: 'Ricevi analisi tecniche approfondite, tesi di investimento quantitative e la mappa giornaliera delle opzioni S&P500 direttamente nella tua email. Contenuti esclusivi per trader che cercano un vantaggio informativo.',
      newsletterBadge1: 'Analisi Quantitativa',
      newsletterBadge2: 'Mappa Opzioni',
      newsletterBadge3: 'Tesi di Investimento',
      whereToInvestTitle: 'Dove Investire',
      whereToInvestSubtitle: 'Puoi seguire le mie strategie quantitative sulle seguenti piattaforme regolamentate. Ogni strategia ha il proprio profilo rischio-rendimento ed è disponibile per copy-trading o investimento diretto.',
      darwinex: {
        title: 'Darwinex',
        description: 'Piattaforma regolamentata FCA per copy-trading di strategie algoritmiche',
        strategies: 'Strategie',
      },
      etoro: {
        title: 'eToro',
        description: 'Piattaforma di social trading con milioni di utenti in tutto il mondo',
        profile: 'Il Mio Profilo',
      },
      wikifolio: {
        title: 'Wikifolio',
        description: 'Piattaforma europea per certificati di strategie investibili',
        profile: 'Il Mio Profilo',
      },
      resourcesTitle: 'Risorse Educative',
      resourcesSubtitle: 'Articoli, strumenti e guide per migliorare il tuo investimento quantitativo',
      comingSoon: 'Prossimamente',
    },

    // Weekly Reports Page  
    weeklyReports: {
      subscriptionOptions: 'Opzioni di Abbonamento',
      subscribeTo: 'Abbonati a',
      subscribed: 'Abbonato',
      cancelsOn: 'Cancella il',
      completeBundle: 'Pacchetto Completo',
      completeBundleDesc: 'Tutte le strategie + Report di mercato + Visioni Quant Macro',
      bestValue: 'MIGLIOR VALORE',
      perMonth: '/mese',
      perYear: '/anno',
      planMonthly: 'Mensile',
      planAnnual: 'Annuale',
      twoMonthsFree: '2 mesi gratis',
      equivMonthly: 'equiv. €{price}/mese',
      savingsText: '(€479,92 individuale — risparmi €184,93 + contenuto macro)',
      savingsTextAnnual: '(€4.799,92 individuale — risparmi €1.849,93 + contenuto macro)',
      getFullAccess: 'Ottieni Accesso Completo',
      includes: 'Include:',
      bundleIncludes: {
        strategies: 'Le 22 strategie (TYR, HRÆSVELGR, ARES, JANUS, BES, FOBOS, DEIMOS, ASCÁLAFO, EOS, ARTEMIS, HELIOS, HYPERION, HORAI, THEIA, ASTRAEUS, PHAETHON, HEMERA, SELENE, ASTERIA, AETHER, HEIMDALL, METIS)',
        weeklyReports: 'Report settimanali con analisi completa',
        macroInsights: 'Visioni macroeconomiche quantitative',
        historicalAccess: 'Accesso all\'archivio storico completo',
        transparentSignals: 'Segnali con ragionamento trasparente',
      },
      exclusiveAccess: 'Accesso Esclusivo',
      exclusiveAccessDesc: 'Report settimanali dettagliati con segnali di trading, analisi di mercato e visioni quantitative',
      loginRequired: 'Login richiesto per accedere ai report',
      noSubscription: 'Non hai un abbonamento attivo',
      subscribeNow: 'Abbonati Ora',
      upcomingReports: 'Report Prossimi',
      historicalReports: 'Archivio Storico',
      reportDate: 'Data del Report',
      viewReport: 'Visualizza Report',
      downloadPDF: 'Scarica PDF',
    },

    // Institutional Investors Page
    institutional: {
      title: 'Investitori Istituzionali',
      subtitle: 'Strategie quantitative di livello istituzionale per family office, hedge fund e gestori patrimoniali',
      exclusiveAccess: 'Accesso Esclusivo',
      loginRequired: 'Login richiesto. Solo per investitori istituzionali abbonati.',
      notSubscribed: 'Non hai un abbonamento istituzionale attivo',
      contactUs: 'Contattaci per informazioni sull\'abbonamento istituzionale',
      whatWeOffer: 'Cosa Offriamo',
      dueDiligence: {
        title: 'Due Diligence Completa',
        description: 'Report dettagliati di backtesting, analisi di stress test e documentazione di strategie per la tua revisione interna',
      },
      customization: {
        title: 'Personalizzazione',
        description: 'Adattiamo le strategie al tuo profilo di rischio, mandato di investimento e requisiti normativi',
      },
      integration: {
        title: 'Integrazione API',
        description: 'Integrazione diretta con i tuoi sistemi di gestione del rischio e piattaforme di esecuzione',
      },
      reporting: {
        title: 'Reporting Dedicato',
        description: 'Dashboard personalizzate e report periodici allineati con i tuoi standard di reporting',
      },
      support: {
        title: 'Supporto Dedicato',
        description: 'Contatto diretto con il team quantitativo per domande, ottimizzazioni e supporto tecnico',
      },
      compliance: {
        title: 'Supporto alla Conformità',
        description: 'Documentazione per la conformità normativa e audit delle strategie',
      },
      getInTouch: 'Mettiamoci in Contatto',
      getInTouchDesc: 'Per discutere come le nostre strategie quantitative possono integrarsi nel tuo portafoglio istituzionale',
      scheduleCall: 'Programma una Chiamata',
    },

    // Contact Page
    contact: {
      title: 'Contatto',
      subtitle: 'Parliamo del tuo investimento quantitativo',
      getInTouch: 'Mettiamoci in Contatto',
      getInTouchDesc: 'Hai domande sulle strategie? Interessato a collaborare? Compila il modulo e ti risponderò al più presto.',
      name: 'Nome',
      email: 'Email',
      subject: 'Oggetto',
      message: 'Messaggio',
      send: 'Invia Messaggio',
      sending: 'Invio in corso...',
      successMessage: 'Messaggio inviato correttamente! Ti risponderò presto.',
      errorMessage: 'Errore nell\'invio del messaggio. Riprova.',
      professionalInquiries: 'Per richieste professionali e collaborazioni istituzionali',
      followMe: 'Seguimi',
      formTitle: 'Inviami un messaggio',
      formName: 'Nome',
      formEmail: 'Email',
      formMessage: 'Messaggio',
      formSubmit: 'Invia messaggio',
      infoTitle: 'Informazioni di contatto',
      emailLabel: 'Email',
      emailLocked: 'Invia la tua email qui sopra per sbloccare',
      linkedinLabel: 'LinkedIn',
      substackLabel: 'Substack',
      fillAll: 'Compila tutti i campi',
      sent: 'Messaggio inviato. Risponderò presto.',
      sendError: 'Errore nell\'invio. Riprova.',
      connectionError: 'Errore di connessione. Riprova più tardi.',
      methodLabel: 'Metodo di contatto',
      methodHint: 'Usa il modulo per inviarmi un messaggio. Di solito rispondo entro 24–48 ore.',
    },

    // Footer
    footer: {
      rights: 'Tutti i diritti riservati',
      disclaimer: 'I rendimenti passati non garantiscono risultati futuri. Il trading comporta rischi.',
      privacy: 'Informativa sulla Privacy',
      terms: 'Termini di Servizio',
      legal: 'Note Legali',
    },

    // Common
    common: {
      present: 'Presente',
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      viewMore: 'Visualizza Altro',
      learnMore: 'Scopri di Più',
      backToTop: 'Torna Su',
      downloadBrochure: 'Scarica Brochure',
    },

    // Terminal Page
    terminal: {
      // General
      quantLab: 'Laboratorio Quantitativo',
      marketData: 'Dati di Mercato',
      derivatives: 'Derivati',
      signals: 'Segnali',
      research: 'Ricerca',
      controls: 'Controlli',
      statistics: 'Statistiche',
      numPaths: 'Numero di Percorsi',
      seed: 'Seme Casuale',
      showPaths: 'Mostra Percorsi',
      showMean: 'Mostra Media',
      showDistribution: 'Mostra Distribuzione',
      showRegimes: 'Colora per Regime',
      terminalMean: 'Media Terminale',
      terminalStd: 'Dev. Std. Terminale',
      theoreticalMean: 'Media Teorica',
      theoreticalStd: 'Dev. Std. Teorica',
      stationaryMean: 'Media Stazionaria',
      stationaryStd: 'Dev. Std. Stazionaria',
      pricePaths: 'Percorsi dei Prezzi',
      meanReversion: 'Processo di Reversione alla Media',
      terminalDistribution: 'Distribuzione Terminale',
      priceWithRegimes: 'Prezzo con Regimi di Mercato',
      regimeStats: 'Statistiche del Regime',
      comingSoon: 'Prossimamente',
      footer: 'Strumento educativo per simulazione di processi stocastici',
      
      // Modules
      macroTerminal: 'Terminal Macro',
      watchlist: 'Lista di Controllo',
      charts: 'Grafici',
      heatmap: 'Mappa di Calore',
      optionsPricing: 'Pricing di Opzioni',
      greeks: 'Calcolatore Greeks',
      volatilitySurface: 'Superficie di Volatilità',
      liveSignals: 'Segnali Live',
      backtest: 'Motore di Backtest',
      economicCalendar: 'Calendario Economico',
      newsAnalysis: 'Analisi delle Notizie',

      // GBM
      gbm: {
        name: 'Moto Browniano Geometrico',
        title: 'Moto Browniano Geometrico',
        subtitle: 'Modello classico per dinamica dei prezzi con drift e volatilità costanti',
      },

      // Ornstein-Uhlenbeck
      ou: {
        name: 'Ornstein-Uhlenbeck',
        title: 'Processo di Ornstein-Uhlenbeck',
        subtitle: 'Processo di reversione alla media usato per tassi d\'interesse, volatilità e pairs trading',
      },

      // Regime Switching
      regime: {
        name: 'Cambio di Regime',
        title: 'Modello di Cambio di Regime',
        subtitle: 'Il comportamento del mercato cambia tra regimi rialzista, neutrale e ribassista',
      },

      // Greeks Explorer
      greeksExplorer: {
        name: 'Esploratore Greeks',
        title: 'GREEKS · SENSIBILITÀ DELLE OPZIONI',
        subtitle: 'Come il prezzo dell\'opzione si muove quando cambiano gli input',
        introTitle: 'Introduzione',
        introContent: 'I Greeks sono derivate parziali della formula Black-Scholes. Ognuno indica come il prezzo dell\'opzione risponde a un cambiamento in un input. I trader professionisti non guardano i prezzi delle opzioni — guardano i Greeks. Un portfolio con Delta = 0 è "delta-neutrale" — immune a piccoli movimenti del sottostante. Un portfolio con Gamma positivo è "long convexity" — beneficia di qualsiasi grande movimento su o giù. Capire i Greeks è capire come funzionano veramente le opzioni.',
        controls: 'Controlli',
        currentGreeks: 'Greeks Attuali',
        callOption: 'OPZIONE CALL',
        putOption: 'OPZIONE PUT',
        price: 'PREZZO',
        labels: {
          spotPrice: 'S (Prezzo Spot)',
          strike: 'K (Strike)',
          timeToExpiry: 'T (Tempo a Scadenza, anni)',
          riskFreeRate: 'r (Tasso Risk-Free)',
          volatility: 'σ (Volatilità)',
        },
        delta: {
          name: 'Δ (DELTA)',
          title: 'Δ (DELTA) · ∂V/∂S',
          description: 'Delta è il rapporto di copertura. Un call con delta 0.5 significa che vendiamo 0.5 azioni per coprire 1 opzione. Delta va da 0 a 1 per i call, da -1 a 0 per i put.',
          formula: 'Formula',
          formulaNote: 'dove Φ è la funzione di distribuzione cumulativa normale standard, e d₁ = [ln(S/K) + (r + σ²/2)T] / (σ√T)',
        },
        gamma: {
          name: 'Γ (GAMMA)',
          title: 'Γ (GAMMA) · ∂²V/∂S² = ∂Δ/∂S',
          description: 'Gamma misura quanto velocemente cambia delta. Gamma alta = delta cambia violentemente con piccoli movimenti di prezzo. Le opzioni ATM hanno il gamma più alto.',
          formula: 'Formula',
          formulaNote: 'dove φ è la funzione di densità di probabilità normale standard: φ(x) = (1/√(2π)) exp(-x²/2)',
        },
        vega: {
          name: 'V (VEGA)',
          title: 'V (VEGA) · ∂V/∂σ',
          description: 'Vega misura la sensibilità alla volatilità. Opzioni lunghe = volatilità lunga. Se σ sale dell\'1%, il prezzo dell\'opzione sale di Vega.',
          formula: 'Formula',
          formulaNote: 'Vega è uguale per call e put. Mostrato per cambio dell\'1% in volatilità.',
        },
        theta: {
          name: 'Θ (THETA)',
          title: 'Θ (THETA) · -∂V/∂t',
          description: 'Theta è il decadimento temporale. Le opzioni lunghe perdono valore col passare del tempo (theta negativo). Le opzioni corte beneficiano (theta positivo) — la pietra angolare della vendita di volatilità.',
          formula: 'Formula',
          formulaNote: 'Mostrato per giorno. Theta è tipicamente negativo per opzioni lunghe (decadimento temporale).',
        },
        rho: {
          name: 'ρ (RHO)',
          title: 'ρ (RHO) · ∂V/∂r',
          description: 'Rho misura la sensibilità ai tassi di interesse. Per opzioni a breve termine, rho è piccolo. Per LEAPS, può contare molto.',
          formula: 'Formula',
          formulaNote: 'Mostrato per cambio dell\'1% nel tasso risk-free.',
        },
        inStrategies: 'Come HMA usa questo',
        fobosStrategy: 'FOBOS opera attivamente la volatilità tramite opzioni. Il Greek chiave per FOBOS è Vega — quando la volatilità implicita è ricca rispetto alla realizzata, FOBOS vende opzioni per raccogliere premio (Vega negativo). Quando la vol implicita crolla sotto la realizzata, FOBOS compra convessità tramite Gamma lungo.',
        ascalafoStrategy: 'ASCÁLAFO esegue strategie sistematiche di opzioni dove Theta e Gamma dominano. Theta è il "rendimento" dalla vendita di tempo, ma Gamma è il rischio — un grande movimento cancella settimane di raccolta theta. L\'arte è dimensionare le posizioni in modo che il rapporto Theta/Gamma valga il rischio.',
      },

      // Black-Scholes Derivation
      bsDerivation: {
        name: 'Derivazione Black-Scholes',
        title: 'BLACK-SCHOLES · DAI PRIMI PRINCIPI',
        subtitle: 'Come viene costruita un\'equazione che vale un Premio Nobel',
        tabs: {
          tab1: '01 · IL PROBLEMA',
          tab2: '02 · BINOMIALE',
          tab3: '03 · REPLICAZIONE',
          tab4: '04 · CONTINUO',
          tab5: '05 · L\'EDP',
          tab6: '06 · FORMULA',
        },
        previous: 'PRECEDENTE',
        next: 'SUCCESSIVO',
        common: {
          stockPrice: 'Prezzo Azione',
          strike: 'K',
          strikePrice: 'Prezzo Strike',
          spotPrice: 'Prezzo Spot',
          timeToExpiry: 'Tempo a Scadenza',
          riskFreeRate: 'Tasso Risk-Free',
          volatility: 'Volatilità',
          initialPrice: 'Prezzo Iniziale',
          upFactor: 'Fattore Su',
          downFactor: 'Fattore Giù',
          timeStep: 'Passo Temporale',
          numberSteps: 'Numero di Passi',
          years: 'a',
        },
        tab1: {
          whatIsOption: 'Cos\'è un\'opzione?',
          whatIsOptionContent: 'Un\'opzione call europea ti dà il diritto (non l\'obbligo) di COMPRARE un attivo a un prezzo fisso K in una data fissa T. Se il prezzo dell\'attivo S_T alla scadenza è sopra K, eserciti e intaschi S_T - K. Se sotto, vai via con zero.',
          payoffFunction: 'La Funzione di Payoff',
          payoffDesc: 'Alla scadenza, l\'opzione vale il suo valore intrinseco: la differenza tra spot e strike, o zero.',
          interactivePayoff: 'Diagramma Interattivo di Payoff',
          stockPriceAtExpiry: 'Prezzo Azione alla Scadenza',
          payoff: 'Payoff',
          callPayoff: 'Payoff Call',
          hockeyStick: 'La forma a mazza da hockey: zero sotto K, lineare sopra K. La linea tratteggiata mostra lo strike.',
          theQuestion: 'La Domanda a cui Black-Scholes Risponde',
          questionText: 'Quanto dovremmo pagare OGGI per il diritto di ricevere max(S_T - K, 0) DOMANI?',
          questionExplanation: 'Il payoff è CONOSCIUTO dato S_T. Il problema è che non sappiamo S_T. Black-Scholes ci mostra come coprire l\'incertezza completamente — sotto assunzioni idealizzate — e così fissare il prezzo equo dell\'opzione.',
          assumptions: 'Assunzioni',
          assumptionsList: [
            'L\'azione segue il Moto Browniano Geometrico (vedi modulo GBM)',
            'Volatilità costante σ',
            'Tasso risk-free costante r',
            'Nessun dividendo, nessun costo di transazione, nessuna tassa',
            'Trading continuo, liquidità perfetta',
            'Esercizio europeo (solo a T, non prima)',
          ],
        },
        tab2: {simplestUniverse: 'L\'universo più semplice', simplestUniverseContent: 'Un passo temporale.', binomialTreeParams: 'Parametri Binomiali', treeValues: 'Valori', up: 'SU', down: 'GIÙ', payoffUp: 'Payoff Su', payoffDown: 'Payoff Giù', wrongApproach: 'Approccio SBAGLIATO', wrongApproachText: 'Media ponderata:', wrongApproachWarning: 'Questo è sbagliato. Il mercato prezza per REPLICAZIONE.'},
        tab3: {centralIdea: 'Idea centrale', centralIdeaContent: 'Costruire un portfolio di azione + contanti.', replicationPortfolio: 'Portfolio di Replicazione', replicationDesc: 'Portfolio = Δ azioni + B contanti', solvingSystem: 'Risoluzione', hedgeRatio: 'RAPPORTO', cash: 'CONTANTI', optionPrice: 'PREZZO', riskNeutralProb: 'Probabilità Risk-Neutral', riskNeutralText1: 'Dopo algebra:', riskNeutralText2: 'dove:', profoundPoint: 'Punto chiave:', profoundText: 'La probabilità reale p non appare mai.', riskNeutralQ: 'q:', discountedPrice: 'Prezzo:'},
        tab4: {nStepIntro: 'N passi → Continuo', nStepContent: 'Estendere a N passi.', crrParams: 'Parametri CRR', crrExplanation: 'Converge a GBM.', convergenceTitle: 'Convergenza', convergenceChart: 'Converge a BS.', continuousLimit: 'Limite Continuo', continuousLimitContent: 'Diventa GBM.'},
        tab5: {derivationIntro: 'Calcolo Stocastico', derivationContent: 'GBM:', itosLemma: 'Lemma Itô', itosContent: 'Per Itô:', hedgePortfolio: 'Portfolio', hedgeContent: 'Π = V - Δ·S', noArbitrage: 'Non-Arbitraggio', noArbitrageContent: 'Tasso risk-free:', noArbitrageExplanation: 'EDP:', bsPDE: 'EDP BS', boundaryConditions: 'Condizioni', boundaryContent: 'Call:', boundaryList: ['V(S,T)=max(S-K,0)', 'V(0,t)=0', 'V→S-K·e^(-r(T-t))'], keyInsight: 'Chiave:', keyInsightContent: 'EDP parabolica.'},
        tab6: {closedFormIntro: 'Formula Chiusa', closedFormContent: 'Soluzione:', bsFormulaCall: 'Formula BS Call', bsFormulaWhere: 'dove:', interactiveCalc: 'Calcolatrice', callPrice: 'CALL', putPrice: 'PUT', priceVsSpot: 'Prezzo vs Spot', bsPrice: 'BS', intrinsicValue: 'Intrinseco', priceChartDesc: 'BS vs intrinseco.', impact: 'Impatto', impactContent: '1973. Nobel 1997.', greeksNext: 'Greeks: derivate parziali.'},
      },
    },
};
